<template>
  <div>
    <div style="page-break-after: always;">
      <div style="width: 100%; text-align: center">
        <button class="btn " id="printbtn" onclick="window.print();" type="button"><i class="fa fa-print"></i> Print Form</button>
      </div>
      <table width="100%">
        <tr>
          <td width="20%">
            <img v-bind:src="institue.Logo" style="width: 100px; height: 100px;">
          </td>
          <td width="60%" style="text-align: center">
            <h3 style="margin-bottom: 0px;">
              {{institue.Name}}
            </h3> 
            <h4 style="margin-top: 5px; margin-bottom: 0px;">
              <!--{{studentinfo[0].Degree}}-->  Student Profile
            </h4>
            <h5 style=" margin-top: 5px; margin-bottom: 0px;">Registration No.: {{st.RegistrationNo}}</h5>
          </td>
          <td width="20%" style="text-align: right;">
            <div style="text-align: center; float:right">
              <img id="img" v-bind:src="st.Image" style="width: 100px; height: 115px;" alt="profile-image">
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="3"></td>
        </tr>
      </table>

      <table width="100%">
        <tr>
          <td width="80%">
            <table width="100%" style="margin-top: 0px; font-size: 12px;">
              <tr>
                <td>
                  <h2>Program Registered in</h2>
                  <hr />
                  <ol style="margin-left: -30px;">
                    <li>{{st.ProgramName}} ({{st.SessionName}}) <small> {{st.SectionName}}</small></li>
                  </ol>
                </td>
              </tr>
              <tr>
                <td>
                  <h2>Prospectus / Admission Form Fee Deposited Vide</h2>
                  <hr />
                </td>
              </tr>
              <tr>
                <td>
                  <table width="100%" style="font-size: 12px; text-align: left;">
                    <tr>
                      <th width="20%" align="left">Challan No.:</th>
                      <td width="30%" align="left">
                        <label style="border-bottom: 1px solid black;">{{st.FormNo}}</label>
                      </td>
                      <th width="20%" align="left">Issue Date:</th>
                      <td width="30%" align="left">
                        <label style="border-bottom: 1px solid black;">{{st.RegistrationDate}}</label>
                      </td>
                    </tr>
                    <tr>
                      <th width="20%" align="left">Amount:</th>
                      <td width="30%" align="left">
                        <label style="border-bottom: 1px solid black;">{{amount}}</label>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <h2>Personal Information</h2>
                  <hr />
                </td>
              </tr>
              <tr>
                <td>
                  <table width="100%" style="font-size: 12px; text-align: left;">
                    <tr>
                      <th width="20%" align="left">Applicant's Name:</th>
                      <td width="30%" align="left">
                        <label style="border-bottom: 1px solid black;">{{st.Name}}</label>
                      </td>
                      <th width="20%" align="left">Fathers's Name:</th>
                      <td width="30%" align="left">
                        <label style="border-bottom: 1px solid black;">{{st.FathersName}}</label>
                      </td>
                    </tr>
                    <tr>
                      <th>Date of Birth:</th>
                      <td>
                        <label style="border-bottom: 1px solid black;">{{st.DateOfBirth}}</label>
                      </td>
                      <th>CNIC # / B Form #:</th>
                      <td>
                        <label style="border-bottom: 1px solid black;">{{st.CNIC}}</label>
                      </td>
                    </tr>
                    <tr>
                      <th>Gender:</th>
                      <td>
                        <label style="border-bottom: 1px solid black;">{{st.Gender}}</label>
                      </td>
                      <th>Nationality:</th>
                      <td>
                        <label style="border-bottom: 1px solid black;">{{st.Nationality}}</label>
                      </td>
                    </tr>
                    <tr>
                      <th>Religion:</th>
                      <td>
                        <label style="border-bottom: 1px solid black;">{{st.Religion}}</label>
                      </td>
                      <th>Email:</th>
                      <td>
                        <label style="border-bottom: 1px solid black;">{{st.Email}}</label>
                      </td>
                    </tr>
                    <tr>
                      <th>Mobile No.:</th>
                      <td>
                        <label style="border-bottom: 1px solid black;">{{st.MobileNo}}</label>
                      </td>
                      <th>WhatsApp No.:</th>
                      <td>
                        <label style="border-bottom: 1px solid black;">{{st.WhatsAppNo}}</label>
                      </td>
                    </tr>
                    <tr>
                      <th>Father Mob:</th>
                      <td>
                        <label style="border-bottom: 1px solid black;">{{st.FatherMobileNo}}</label>
                      </td>
                      <th>Village/Town/City::</th>
                      <td>
                        <label style="border-bottom: 1px solid black;">{{st.City}}</label>
                      </td>

                    </tr>

                    <tr>
                      <th>Domicile City:</th>
                      <td>
                        <label style="border-bottom: 1px solid black;">{{st.Domicile}}</label>
                      </td>
                      <th>District:</th>
                      <td>
                        <label style="border-bottom: 1px solid black;">{{st.District}}</label>
                      </td>
                    </tr>
                    <tr>
                      <th>Tehsil:</th>
                      <td>
                        <label style="border-bottom: 1px solid black;">{{st.Tehsil}}</label>
                      </td>
                      <th>Permanent Address:</th>
                      <td align="left">
                        <label style="border-bottom: 1px solid black;">{{st.Address}}</label>
                      </td>
                    </tr>
                    <tr>
                      <th>Present/Postal Address:</th>
                      <td align="left">
                        <label style="border-bottom: 1px solid black;">{{st.PostalAddress}}</label>
                      </td>
                      <th>Postal Code:</th>
                      <td align="left">
                        <label style="border-bottom: 1px solid black;">{{st.PostalCode}}</label>
                      </td>
                    </tr>
                    <tr>
                      <th v-if="st.Disability">Disability:</th>
                      <td v-if="st.Disability">
                        <label style="border-bottom: 1px solid black;">{{st.Disability}}</label>
                      </td>
                      <th>Hostel Required:</th>
                      <td>
                        <label style="border-bottom: 1px solid black;">{{st.HostelRequired}}</label>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <h2>Academic Record</h2>
                  <hr />
                </td>
              </tr>
              <tr>
                <td>
                  <table width="100%" border="1" cellspacing="0" style="font-size: 12px; text-align: left;">
                    <tr style="background-color: black !important; color: white">
                      <th>Certificate/Degree</th>
                      <th>Passing Year</th>
                      <th>Roll No.</th>
                      <th>Board/University</th>
                      <th>Total Marks</th>
                      <th>Obtained Marks</th>
                      <th>%</th>
                      <th>Grade</th>
                      <th>Major Subject</th>
                    </tr>
                    <tr v-for="item in education">
                      <td>{{item.DegreeName}} </td>
                      <td align="center">{{item.PassingYear}} </td>
                      <td>{{item.RollNo}} </td>
                      <td>{{item.InstituteName}} </td>
                      <td align="right">{{item.TotalMarks}} </td>
                      <td align="right">{{item.ObtainedMarks}}</td>
                      <td align="right">{{((Number(item.ObtainedMarks) * 100) / Number(item.TotalMarks)).toFixed(3)}}</td>
                      <td>{{item.Division}} </td>
                      <td>{{item.MajorSubjects}} </td>
                    </tr>
                  </table>
                </td>
              </tr> 
            </table>
          </td>
        </tr>
      </table>
    </div>

    <!--<div style="page-break-after: always;">
      <div v-html="af.guideline"></div>
    </div>-->

    <!--<div style="page-break-after: always;">
      <div v-html="af.undertaking"></div>
    </div>-->
  </div>
</template>

<script>
  const axios = require('axios').default;
  export default ({
    data() {
      return { 
        studentinfo: [],
        institue: [],
        terms: '',
        prospect_student_Education: [], 
        amount: 0,
        choices: [], image: '', sum: 0, choices2: [],
        st: {
          StudentRegistrationID: 0,
          OldRollNo: 0,
          RegistrationNo: '',
          FormNo: '',
          District: '',
          Tehsil: '',
          Name: '',
          ProgramName: '', 
          CNIC: '', 
          FathersName: '',
          Disability: 'false',
          DisabilityType: null,
          FatherCNIC: '',
          FatherMobileNo: '', 
          Hafiz: 'false',
          Country: '',
          Religion: '',
          Gender: '',
          MobileNo: '',
          City: '',
          LandLineNo: '',
          Domicile: '',
          Address: '',
          PostalAddress: '',
          DateOfBirth: '', 
          //Email: '',
          BloodGroup: '',
          HostelRequired: false, 
          Type: 'Regular',
          AdmissionCategoryID: '',
          IsOnline: 'true',
          Remarks: '',
          RelativeRelation: '',
          RelativeMobileNo: '',
          RelativeName: '',
          PostDate: ''
        },
        education: [],
      }
    },

    created: function () {
      this.get_student_info();
    },

    methods: {
      get_student_info() {
        var vm = this;
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        var id = urlParams.get("id");
        axios.post('/api/StudentsApi/printProfile?id=' + id)
          .then(function (response) {
            vm.st = response.data.st;
            vm.education = response.data.edu;
            vm.amount = response.data["amount"];  
            vm.institue = response.data.institue;  
            
          })
          .catch(function (Error) {
            console.log(Error);
          });
      },

      date() {
        Vue.filter('formatDate', function (value) {
          if (value) {
            return moment(String(value)).format('MM/DD/YYYY hh:mm')
          }
        })
      },
    }

  })
</script>

<style>
  body {
    font-size: 10px;
  }

  .padding {
    padding: 0px;
  }

  .margin {
    margin: 0px;
  }

  .fontSize {
    font-size: 10px;
  }

  hr {
    margin-top: -12px;
  }

  @page {
    size: portrait;
  }

  @media print {
    #printbtn {
      display: none;
    }
  }

  .btn {
    background-color: #438eb9;
    color: white;
    padding-top: 4px;
    padding-bottom: 4px;
    cursor: pointer;
  }

  #img {
    padding: 1px;
    border: 1px solid #021a40;
  }
</style>



// WEBPACK FOOTER //
// src/components/DC/StudentAdmissionPrint.vue